// Person photos come from two worlds: AI research / social profiles (absolute
// external URLs) and our own /uploads/** media (relative paths served from
// the API host - see WebConfig). <img> tags need the API prefix for the
// latter; event/slides media already prefix unconditionally where they render,
// but person photos must stay bare for external URLs - so this decides per
// value instead.
const API = process.env.REACT_APP_API_URL || '';

export const mediaUrl = (url) => (url && url.startsWith('/uploads') ? `${API}${url}` : url);
